<template>
  <div class="proxyList-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input placeholder="代理ID" size="small" clearable class="param-input" v-model="form.uid"></el-input>
      <el-button type="primary" size="small" @click="search(form)">搜索</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table :data="tableData" border style="width: 100%" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <el-table-column prop="uid" label="代理ID" align="center" width="160" fixed></el-table-column>
      <el-table-column prop="promotionCode" label="推广码" align="center" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.promotionCode || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="lv1" label="一级业绩总额（元）" align="center" width="160">
        <template slot-scope="scope">
          <span>{{(scope.row.lv1/100 || '0') | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="lv2" label="二级业绩总额（元）" align="center" width="160">
        <template slot-scope="scope">
          <span>{{(scope.row.lv2/100 || '0') | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="lv3" label="三级业绩总额（元）" align="center" width="160">

        <template slot-scope="scope">
          <span>{{(scope.row.lv3/100 || '0') | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="lv4" label="四级业绩总额（元）" align="center" width="160">

        <template slot-scope="scope">
          <span>{{(scope.row.lv4/100 || '0') | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="total" label="总业绩（元）" align="center" width="120">

        <template slot-scope="scope">
          <span>{{(scope.row.total/100 || '0') | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="withdraw" label="提现总金额（元）" align="center" width="140">

        <template slot-scope="scope">
          <span>{{(scope.row.withdraw/100 || '0') | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="withdrawCount" label="提现次数" align="center">

        <template slot-scope="scope">
          <span>{{(scope.row.withdrawCount/100 || '0') | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="a" label="更新时间" align="center" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.a || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="a" label="操作时间" align="center" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.a || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="operating" label="操作" align="center" width="160" fixed="right">
        <template slot-scope="scope">
          <el-button type="success" size="mini" @click="tagsAction(scope.row.uid)">详情记录</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <!-- <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="form.pageNumber" :page-size="form.pageSize" layout="total, sizes, prev, pager, next, jumper" background :total="total" @size-change="changeSize" @current-change="changeCurrent"></el-pagination> -->
    <!--详情记录弹窗-->
    <detail-record ref="detailRecord"></detail-record>
  </div>
</template>
<script>
import DetailRecord from './components/detailRecord'
import API from '@/api'

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      tableData: [],
      total: 0,
      //代理列表请求参数
      form: {
        uid: ''
      }
    }
  },
  components: {
    DetailRecord
  },
  methods: {
    // 详情记录
    tagsAction(data) {
      this.$refs.detailRecord.open(data);
    },
    // 请求搜索代理列表数据
    getProxyList() {
      var arr = [];
      if (!this.form.uid) {
        this.$message.error('请输入代理ID');
        return false
      } else {
        this.loading = true;
        API.getProxyList(this.form).then(res => {
          if (res.code === 200 && res.data) {
            arr.push(res.data)
            this.tableData = arr
          } else {
            this.tableData = []
            this.total = 0
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      }
    },
    // 搜索对应列表
    search() {
      this.getProxyList();
    },
    // pageSize发生变化触发
    // changeSize(size) {
    //   this.form.pageSize = size
    //   this.form.pageNumber = 1
    //   this.getProxyList()
    // },
    // 当前页发生变化触发
    // changeCurrent(pageNumber) {
    //   this.form.pageNumber = pageNumber
    //   this.getProxyList()
    // }
  }
}
</script>
